/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Report } from "./Report";
import { ReportFromJSON, ReportFromJSONTyped, ReportToJSON, ReportToJSONTyped } from "./Report";

/**
 *
 * @export
 * @interface ApiGpdReportsList200Response
 */
export interface ApiGpdReportsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGpdReportsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGpdReportsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGpdReportsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Report>}
   * @memberof ApiGpdReportsList200Response
   */
  results: Array<Report>;
}

/**
 * Check if a given object implements the ApiGpdReportsList200Response interface.
 */
export function instanceOfApiGpdReportsList200Response(
  value: object
): value is ApiGpdReportsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGpdReportsList200ResponseFromJSON(json: any): ApiGpdReportsList200Response {
  return ApiGpdReportsList200ResponseFromJSONTyped(json, false);
}

export function ApiGpdReportsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGpdReportsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(ReportFromJSON),
  };
}

export function ApiGpdReportsList200ResponseToJSON(json: any): ApiGpdReportsList200Response {
  return ApiGpdReportsList200ResponseToJSONTyped(json, false);
}

export function ApiGpdReportsList200ResponseToJSONTyped(
  value?: ApiGpdReportsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(ReportToJSON),
  };
}
